<mat-toolbar class="mat-elevation-z3" color="primary">
    <button mat-icon-button (click)="collapsed.set(!collapsed())">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="logo">
        <img class="img" src="../assets/logo-sura.svg" alt="logo" />
    </div>
    <div class="mr-2 cerrar-sesion">
        <span class="usuario">{{nombreUsuario}}</span>
        <p-button icon="pi pi-sign-out" class="mr-2" text severity="secondary" (click)="cerrarSesion()" />
    </div>
</mat-toolbar>

<mat-sidenav-container>
    <mat-sidenav opened mode="side" [style.width]="sidenavWidth()">
        <sura-menu [collapsed]="collapsed()"></sura-menu>
    </mat-sidenav>
    <mat-sidenav-content class="content" [style.margin-left]="sidenavWidth()">
        <!-- Dialog de Confirmación (con dos botones) -->
        <p-confirmdialog #cd>
            <ng-template pTemplate="headless" let-message let-onAccept="onAccept" let-onReject="onReject">
                <div class="dialog-container">
                    <div class="dialog-icon">
                        <i class="pi pi-question"></i>
                    </div>
                    <h2 class="dialog-header">{{ message.header }}</h2>
                    <p class="dialog-message">{{ message.message }}</p>
                    <p-divider />
                    <div class="dialog-buttons">
                        <p-button label="No" icon="pi pi-times" [raised]="true" [rounded]="true" severity="secondary"
                            (onClick)="onReject()"></p-button>
                        <p-button label="Si" icon="pi pi-check-circle" [raised]="true" [rounded]="true"
                            (onClick)="onAccept()"></p-button>
                    </div>
                </div>
            </ng-template>
        </p-confirmdialog>

        <!-- Dialog de Alerta (con un solo botón) -->
        <p-confirmdialog key="alert-dialog">
            <ng-template pTemplate="headless" let-message let-onAccept="onAccept">
                <div class="dialog-container">
                    <div class="dialog-icon alert-icon">
                        <i class="pi pi-exclamation-triangle"></i>
                    </div>
                    <h2 class="dialog-header">{{ message.header }}</h2>
                    <p class="dialog-message">{{ message.message }}</p>
                    <p-divider />
                    <div class="dialog-buttons">
                        <p-button label="Aceptar" icon="pi pi-check" [raised]="true" [rounded]="true" severity="primary"
                            (onClick)="onAccept()"></p-button>
                    </div>
                </div>
            </ng-template>
        </p-confirmdialog>

        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<p-toast position="bottom-right" [preventOpenDuplicates]="true">
</p-toast>